import { render, staticRenderFns } from "./TaskSettingTab.vue?vue&type=template&id=2dc86206&scoped=true&"
import script from "./TaskSettingTab.vue?vue&type=script&lang=js&"
export * from "./TaskSettingTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc86206",
  null
  
)

export default component.exports